import { v4 as uuidv4 } from 'uuid'
const Images = [
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/website_images/,
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/website_images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/website_images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Blog", 
        imgsrc: "./Images/website_images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
]
export default Images
